import { type UploadPhotosFormState } from '../model/type'

export const uploadPhotosFormDefault: UploadPhotosFormState = {
  obj_id: 1,
  owner: 1,
  photos: [],
}
